import React, { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import useGoogleMapsPlaces from '../hooks/useGoogleMapsPlaces';

const SearchForm = ({ onSearch, loading }) => {
    const { user, signInWithGoogle } = useContext(AuthContext);
    const [address, setAddress] = useState('');
    const [category, setCategory] = useState('');
    const autocompleteContainerRef = useRef(null);

    // Cargamos el JS de Google Maps (que factura) solo si hay usuario autenticado.
    const { placesLib, loaded: mapsLoaded } = useGoogleMapsPlaces(!!user);

    useEffect(() => {
        if (!user) return;
        if (!mapsLoaded || !placesLib) return;
        const container = autocompleteContainerRef.current;
        if (!container) return;

        // PlaceAutocompleteElement es el reemplazo moderno del viejo Autocomplete.
        // Pertenece a Places API (New) y usa un modelo de cobro más económico.
        const el = new placesLib.PlaceAutocompleteElement({
            includedPrimaryTypes: ['locality', 'postal_town', 'administrative_area_level_3'],
            requestedLanguage: 'es',
        });
        el.classList.add('pac-modern-input');

        const handleSelect = async (event) => {
            try {
                const placePrediction = event.placePrediction;
                const place = placePrediction.toPlace();
                await place.fetchFields({ fields: ['formattedAddress', 'displayName'] });
                setAddress(place.formattedAddress || place.displayName || '');
            } catch (err) {
                // Si falla la obtención, mantenemos lo que el usuario tipeó.
            }
        };

        el.addEventListener('gmp-select', handleSelect);
        container.innerHTML = '';
        container.appendChild(el);

        return () => {
            el.removeEventListener('gmp-select', handleSelect);
            if (container.contains(el)) container.removeChild(el);
        };
    }, [user, mapsLoaded, placesLib]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!user) {
            signInWithGoogle();
            return;
        }
        try {
            onSearch({ address, category });
        } catch (_) {}
    };

    if (!user) {
        return (
            <div className="search-form search-form-locked">
                <p className="search-form-locked-text">
                    Iniciá sesión para buscar contactos.
                </p>
                <button
                    type="button"
                    className="btn-primary"
                    onClick={signInWithGoogle}
                >
                    Iniciar sesión con Google
                </button>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="search-form">
            <div className="form-group">
                <label>Ciudad:</label>
                <div
                    ref={autocompleteContainerRef}
                    className="autocomplete-container"
                    aria-label="Ciudad"
                />
                {/* Input de backup por si el autocomplete aún no cargó. */}
                {!mapsLoaded && (
                    <input
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="Ej: Buenos Aires, Argentina"
                        required
                    />
                )}
            </div>
            <div className="form-group">
                <label>Rubro (ej: restaurant, store):</label>
                <input
                    type="text"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    placeholder="Ej: restaurant, store, hotel"
                    required
                />
            </div>
            <button
                type="submit"
                className="btn-primary"
                disabled={loading || !address}
            >
                {loading ? 'Buscando...' : 'Buscar'}
            </button>
        </form>
    );
};

export default SearchForm;
